import axios from 'axios';
import setting from '@/api/setting';
import { Message } from 'element-ui';

export default function (url, fileName) {
  const isPrivateFile = url.split(':');
  if(isPrivateFile.length === 1 && isPrivateFile[0] !== 'https') {
    // 私密文件
    setting.getSignedUrl(encodeURIComponent(url))
      .then(result => {
        downloadFn(result.data, fileName);
      });
  } else {
    // 未加密文件
    downloadFn(url, fileName);
  }
}

// 下载文件
const downloadFn = (url, fileName) => {
  const downloadMessageClass = `downloadMessage-${Date.now()}`;
  const msgAlert = Message({
    message: ' 文件下载中,请稍后...',
    type: 'success',
    iconClass: 'el-icon-loading',
    duration: 100000000,
    customClass: downloadMessageClass
  });
  const msgDom = document.querySelector(`.${downloadMessageClass}`).querySelector('.el-message__content');
  axios({
    method: 'get',
    url: url,
    responseType: 'blob', // 服务器返回的数据类型
    onDownloadProgress: (progressEvent) => { // 下载进度
      const progress = (progressEvent.loaded / progressEvent.total * 100 | 0);
      msgDom.innerHTML = `下载进度：${progress}%，请稍后...`;
    }
  })
  .then(
    response => {
      const blob = new Blob([response.data], { type: 'text/csv' });
      // IE
      if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        navigator.msSaveBlob(blob, fileName);
      } else {
        const a = document.createElement('a');
        a.href = URL.createObjectURL(blob);
        a.download = fileName;
        a.style.display = 'none';
        document.body.appendChild(a);
        a.click();
        URL.revokeObjectURL(a.href);
        document.body.removeChild(a);
      }
      // 关闭下载进度提示
      msgAlert.close();
    },
    err => {
      console.log(err);
    },
  );
}